// extracted by mini-css-extract-plugin
module.exports = {"AgeGateModal":"AgeGateModal_AgeGateModal__1IT1c","buttonWrapper":"AgeGateModal_buttonWrapper__hfpgM","cancelButton":"AgeGateModal_cancelButton__w8EPj"};